import { HostProps } from './host-props';

export const HiroEntryService = Symbol('HiroEntryService');

export interface HiroBasicConfig {
    name: string;
    url: string;
    enabled: boolean;
    /** 开启的智能体 code */
    enabledAgentCodes: string[];
    /** 智能体配置, key 为智能体 code, value 为智能体配置 */
    agentConfigs: Record<string, {
        /** 是否开启读图功能 */
        enable_read_image?: boolean;
        ai_filter_case?: Array<{
            task_id: string;
            label_key: string;
        }>;
        selected_limit?: number;
    }>;
}


export interface HiroProps {
    defaultMenu?: 'HiroChat' | 'HiroAgentManager';
    defaultAgentCode?: string;
    /**
     * 智能体 code 范围, 不在范围内的 agent 将被隐藏（可以从历史查看）
     * 不传则显示所有智能体
     * 传空数组则不显示任何智能体
     */
    agentCodeScope?: string[];
    /**
     * wujie 是否保活
     * true 时，组件销毁时 wujie 实例不会被销毁，反之则会被销毁
     */
    alive?: boolean;
}

/** 需要业务实现 */
export interface HiroEntryService {
    getHiroBasicConfig(): Promise<HiroBasicConfig>;

    getWujieProps(basicConfig: HiroBasicConfig): HostProps;

    getHiroProps(): HiroProps;
}
